/** `?templates=true` opens the new automation's workflow on the template picker. */
export type WelcomeCreateSearch = {
  templates?: true;
};

/** The param as `validateSearch` receives it: the router has JSON-parsed `true`, a quoted one stays a string. */
type UnvalidatedWelcomeCreateSearch = {
  templates?: unknown;
};

export function validateWelcomeCreateSearch({ templates }: UnvalidatedWelcomeCreateSearch): WelcomeCreateSearch {
  return templates === true || templates === 'true' ? { templates: true } : {};
}
